<template>
  <div>
    <card v-if="location.countryCode !== undefined"
      :title= "$t('pages.adhoc_session.labels.location_info')">
      <el-row class="mb-4">
        <el-col v-if="location.locationId" :xs="24" :sm="12" :lg="6" class="md-3">
          <label>
            {{ $t("pages.adhoc_session.labels.id") }}
            <p>{{ location.locationId }}</p>
          </label>
        </el-col>
        <el-col v-if="location.name" :xs="24" :sm="12" :lg="6" class="md-3">
          <label>
            {{ $t("pages.adhoc_session.labels.name") }}
            <p>{{ location.name }}</p>
          </label>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="6" class="md-3">
          <label>
            {{ $t("pages.adhoc_session.labels.address") }}
            <p>{{ location.address }}</p>
          </label>
        </el-col>
        <el-col :xs="12" :sm="12" :lg="6" class="md-3">
          <label>
            {{ $t("pages.adhoc_session.labels.city") }}
            <p>{{ location.city }}</p>
          </label>
        </el-col>
        <el-col :xs="12" :sm="12" :lg="6" class="md-3">
          <label>
            {{ $t("pages.adhoc_session.labels.country") }}
            <p>{{ location.country }}</p>
          </label>
        </el-col>
      </el-row>
    </card>
    <card v-if="location.countryCode === undefined" class="centered-content">
      <div>
        <p>{{ $t("pages.adhoc_session.labels.no_location") }}</p>
      </div>
    </card>

    <card v-if="session !== undefined" 
      v-loading="loading_session"
      :title="$t('pages.adhoc_session.labels.session_info')" >
      <el-row class="mb-4">
        <el-col :xs="24" :sm="24" :lg="24" class="md-3">
          <label>
            {{ $t("pages.adhoc_session.labels.status") }}
            <p>{{ $t("pages.adhoc_session.status." + session.status) }}</p>
          </label>
        </el-col>
      </el-row>
      <el-row class="mb-4">
        <el-col :xs="12" :sm="12" :lg="6" class="md-3">
          <label>
            {{ $t("pages.adhoc_session.labels.energy_consumed") }}
            <p>{{ session.kwh }} kWh</p>
          </label>
        </el-col>
        <el-col v-if="session.total_cost" :xs="12" :sm="12" :lg="6" class="md-3">
          <label>
            {{ $t("pages.adhoc_session.labels.total_cost_inc_vat") }}
            <p>{{ round(session.total_cost.incl_vat, 2) + " " + getCurrencySymbol(session.currency) }}</p>
          </label>
        </el-col>
        <el-col
          :xs="12"
          :sm="12"
          :lg="6"
          class="md-3"
          v-if="session.start_date_time"
        >
          <label>
            {{ $t("pages.adhoc_session.labels.start_date") }}
            <p>{{ datetimeStart.split(" ")[0].slice(0, -1).replaceAll("/", "-") }}</p>
          </label>
        </el-col>
        <el-col
          :xs="12"
          :sm="12"
          :lg="6"
          class="md-3"
          v-if="session.start_date_time"
        >
          <label>{{ $t("pages.adhoc_session.labels.start_time") }}
            <p>{{ datetimeStart.split(" ")[1].slice(0, -3) }}</p>
          </label>
        </el-col>
        <el-col
          :xs="12"
          :sm="12"
          :lg="6"
          class="md-3"
          v-if="session.end_date_time"
        >
          <label>
            {{ $t("pages.adhoc_session.labels.end_date") }}
            <p>{{ datetimeEnd.split(" ")[0].slice(0, -1).replaceAll("/", "-") }}</p>
          </label>
        </el-col>
        <el-col
          :xs="12"
          :sm="12"
          :lg="6"
          class="md-3"
          v-if="session.end_date_time"
        >
          <label>{{ $t("pages.adhoc_session.labels.end_time") }}
            <p>{{ datetimeEnd.split(" ")[1].slice(0, -3) }}</p>
          </label>
        </el-col>
      </el-row>
    </card>
    <card
      v-if="!session" class="centered-content"
      style="background-color:aliceblue; padding-bottom:0%"
      v-loading="loading_session"
    >
      <div>
        <p>{{ $t("pages.adhoc_session.labels.no_session") }}</p>
      </div>
    </card>
    <div
      style="margin: 0; text-align: center;"
      v-loading="loading_session"
    >
      <el-button class="button" @click="refresh()" :round=true>
        {{ $t("pages.adhoc_session.labels.refresh").toUpperCase() }}
      </el-button>
      <el-button class="button" v-if="!session" @click="goBack()" :round=true>
        {{ $t("pages.adhoc_session.labels.go_back").toUpperCase() }}
      </el-button>
      <el-button v-if="session && !completed" class="button" @click="stop()" :round=true>
        {{ $t("pages.adhoc_session.labels.stop_session").toUpperCase() }}
      </el-button>
      <el-button class="button" v-if="session && completed" @click="newSession()" :round=true>
        {{ $t("pages.adhoc_session.labels.new_session").toUpperCase() }}
      </el-button>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import { getCurrency } from "../services/tariff/curencies";
const { mapMutations, mapGetters, mapActions } = createNamespacedHelpers(
  "session"
);

export default {
  data() {
    return {
      session: undefined,
      token: this.getSessionToken(),
      location: this.getLocation(),
      session_status: this.getSessionStatus(),
      loading_session : undefined,
      pollingIntervalId: null
    };
  },
  computed: {
    completed() { 
      const status = this.getSessionStatus()
      return status == "Completed"
    },
    datetimeStart() {
      if(this.location.timezone){
        return new Date(this.session.start_date_time).toLocaleString("en-GB", {timeZone: this.location.timezone});
      } else {
        return new Date(this.session.start_date_time)
      }
    },
    datetimeEnd() {
      if(this.location.timezone){
        return new Date(this.session.end_date_time).toLocaleString("en-GB", {timeZone: this.location.timezone});
      } else {
        return new Date(this.session.end_date_time)
      }
    }    
  },
  methods: {
    ...mapGetters([
      "getSessionStatus",
      "getLocation",
      "getSessionToken"
    ]),
    ...mapMutations(["changeStatusToActive", "changeStatusToCompleted", "clear"]),
    ...mapActions(["getSession", "getCommand", "stopSession", "startSession"]),
    startPolling() {
      this.pollingIntervalId = setInterval(async () => {
        const response = await this.getSession(this.token.uid)
        if (response.status === 200 && response.data.data) {
          const updatedSession = response.data.data
          if (updatedSession.status === "COMPLETED") {
            this.session = updatedSession
            this.changeStatusToCompleted()
            this.stopPolling()

            const messageKey = updatedSession.emmaStopReason === "AUTO_STOP_MAX_COST_SIBS"
              ? "pages.adhoc_session.labels.stop_session_auto_stopped"
              : "pages.adhoc_session.labels.stop_session_sucess"

            this.$alert(
              this.$t(messageKey),
              "Session stopped",
              {
                confirmButtonText: "Ok",
                type: "success",
                closeOnClickModal: false,
                closeOnPressEscape: false
              }
            )
          }
        }
      }, 30000)
    },
    stopPolling() {
      if (this.pollingIntervalId) {
        clearInterval(this.pollingIntervalId)
        this.pollingIntervalId = null
      }
    },
    async refresh() {
      this.loading_session = true
      let response = await this.getSession(this.token.uid)
      this.loading_session = false
      if (response.status === 200) {
        this.session = response.data.data;
        
        if (this.session.status === "ACTIVE") {
          this.changeStatusToActive()
        } else if (this.session.status === "COMPLETED") {
          if (this.session.emmaAutoStopped) {
            this.stopPolling()
            
            this.$alert(
              this.$t("pages.adhoc_session.labels.stop_session_auto_stopped"),
              this.$t("Session stopped"),
              {
                confirmButtonText: this.$t("Ok"),
                type: "success",
                closeOnClickModal: false,
                closeOnPressEscape: false
              }
            )
          }
          this.changeStatusToCompleted()
        }
      }
    },
    async stop() {
      this.$confirm(
        this.$t('pages.adhoc_session.labels.stop_session_confirm'),
        "Warning",
        {
          confirmButtonText: this.$t('pages.adhoc_session.labels.stop_session'),
          cancelButtonText: this.$t('pages.adhoc_session.labels.stop_session_cancel'),
          type: "warning",
          customClass: "message-box",
          confirmButtonClass: "message-box-confirm-button",
          cancelButtonClass: "message-box-cancel-button" ,
          roundButton: true
        }
      )
        .then(async () => {
          this.stopPolling()
          this.loading_session = true
          let response = await this.stopSession(this.session.id)

          this.$console("log", "GET STOP RESPONSE:");
          this.$console("log", response);

          if (response.status === 200 && response.data.data.code === 3008) {
            this.refresh()
          } else if (response.status === 200 && response.data.data.response.result  !== "ACCEPTED") {
            let message = "enum.errors." + response.data.data.code
            this.$message({
              type: "error",
              message:
                this.$t('pages.adhoc_session.labels.stop_session_failed') + this.$t(message)
            });
          } else {
            this.$console("log", response.headers["command-uid"]);
            let commandUid = response.headers["command-uid"];

            const snooze = ms => new Promise(resolve => setTimeout(resolve, ms));
            // wait for it to be accepted
            let count = 5;
            while (count >= 1) {
              let commandResponse = await this.getCommand(commandUid)

              if (commandResponse.status === 200 ) {
                if (commandResponse.data.data.result.result.result === "ACCEPTED") {
                  this.$message({
                    type: "success",
                    message: this.$t('pages.adhoc_session.labels.stop_session_sucess')
                  });
                  const snooze = ms => new Promise(resolve => setTimeout(resolve, ms));

                  let count = 12;
                  while (count >= 1) {
                    let response = await this.getSession(this.token.uid)
                    this.$console("jog", JSON.stringify(response))
                    if (response.status === 200 & response.data.data.status === "COMPLETED") {
                      this.session = response.data.data;
                      // change status in vuex store
                      this.changeStatusToCompleted()
                      break
                    }
                    await snooze(5000);
                    count--;
                  }
                  break
                }
                else if (commandResponse.data.data.result.result.result === "WAITING") {
                  //do nothing, next cycle
                }
                else {
                  this.$message({
                    type: "error",
                    message: this.$t('pages.adhoc_session.labels.stop_session_failed')
                  });
                  break
                }
              }
              await snooze(5000);
              count--;
            }
            if (count == 0) {
              this.$message({
                type: "error",
                message: this.$t('pages.adhoc_session.labels.stop_session_failed')
              });
            }
          }
          this.loading_session = false
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('pages.adhoc_session.labels.stop_session_failed')
          });
        });
    },
    goBack(){
      this.$router.replace({
        name: "SessionConfirm",
        params: {
          reload: false
        }
      });        
    },
    newSession() {
      const location = JSON.parse(JSON.stringify(this.getLocation()))
      this.clear()
      const params = {
        countryCode: location.countryCode,
        partyId: location.partyId,
        locationId: location.locationId,
        reload: false
      }
      this.$router.replace({
        name: "PaymentMethod",
        params
      });
    },
    getCurrencySymbol(currency) {
      const symbol = getCurrency(currency)
      return symbol ? symbol : currency
    },
    round(n, decimals = 4) {
      const p = Math.pow(10, decimals);
      return Math.round((n * p) * (1 + Number.EPSILON)) / p;
    }
  },
  async mounted() {

    this.loading_session = true
    const snooze = ms => new Promise(resolve => setTimeout(resolve, ms));

    let count = 12;
    while (count >= 1) {
    
      let response = await this.getSession(this.token.uid)
      this.$console("log", JSON.stringify(response))
      if (response.status === 200 & response.data.data !== undefined) {
        this.session = response.data.data;
        // change status in vuex store
        if (this.session.status === "ACTIVE") {
          this.changeStatusToActive()
          this.startPolling()
        } else if (this.session.status === "COMPLETED") {
          this.changeStatusToCompleted()
        }
        break
      }
      await snooze(5000);
      count--;
    }
    this.loading_session = false
  },
  beforeDestroy() {
    this.stopPolling()
  }
};
</script>
<style lang="scss" scoped>

</style>